export const patientExistError = {
  title: "Registro detectado",
  message: "Hemos detectado que ya estabas registrado previamente en Happ.\n\nEstas listo para disfrutar tu experiencia en Happ",
  buttonName: "Volver"
}

export const missingConsentError = {
  title: "Registro detectado",
  message: "Tu registro existe, pero aún nos falta la firma de consentimiento.\n\nAhora puedes continuar con el proceso.",
  buttonName: "Firmar consentimiento"
}